import axios from 'axios';
import authHeader from './auth-header';
import { getUrl } from './service-utils';

const API_URL = getUrl();

export interface PexelsPhoto {
  id: number;
  width: number;
  height: number;
  url: string;
  photographer: string;
  src: {
    original: string;
    large2x: string;
    large: string;
    medium: string;
    small: string;
    portrait: string;
    landscape: string;
    tiny: string;
  };
}

export const findImage = async (
  searchText: string,
  orientation?: string
): Promise<any> => {
  const tmpData = await axios.post(
    API_URL + 'pexels/findimage',
    orientation
      ? { searchText: searchText, orientation: orientation }
      : { searchText: searchText },
    {
      headers: authHeader()
    }
  );
  return tmpData.data;
};

export const findImage_Portrait = async (searchText: string): Promise<any> => {
  return await findImage(searchText, 'portrait');
};

export const findImage_Landscape = async (searchText: string): Promise<any> => {
  return await findImage(searchText, 'landscape');
};

export const findIconicImage = async (searchText: string): Promise<any> => {
  return await findIconicImage(searchText + ' iconic landmark');
};
